import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { createContext, JSX, useContext, useState } from 'react';
import Icon from './Icon';


const ModalContext = createContext<IModalProvider | null>(null);

interface IModalProviderContent { title?: string, description?: JSX.Element }
interface IModalProvider {
	handleModalOpen: ({ title, description }: IModalProviderContent) => void;
	handleModalClose: () => void;
}

export function ModalProvider({ children }: any) {
	const [open, setOpen] = useState(false);
	const [modalInfo, setModalInfo] = useState<IModalProviderContent | null>(null);

	const handleModalOpen = (props: IModalProviderContent) => {
		setOpen(true)
		setModalInfo(props)
	}
	const handleModalClose = () => setOpen(false)

	return (
		<ModalContext.Provider value={{ handleModalOpen, handleModalClose }}>
			{
				[
					children,
					<Dialog key={"dialog"} open={open} onClose={setOpen} className="relative z-[1000]">
						<DialogBackdrop
							transition
							className="fixed inset-0 bg-gray-500 bg-opacity-70 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
						/>

						<div className="fixed inset-0 z-10 w-screen overflow-y-auto">
							<div className="flex min-h-full justify-center p-4 items-center sm:p-0">
								<DialogPanel
									transition
									className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-full max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
								>
									<div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
										<div className="sm:flex sm:items-start">
											<div className="w-full mt-3 sm:ml-4 sm:mt-0 sm:text-left">

												<DialogTitle as="h3" className="text-gray-900 text-lg font-semibold font-inter leading-[28px] flex items-center justify-between">
													<span>{modalInfo?.title || "Info"}</span>
													<button className="bg-transparent outline-none m-0 p-0"
														onClick={() => setOpen(false)}>
														<Icon icon="close" classNameIcon="w-6 h-6" />
													</button>
												</DialogTitle>
												{modalInfo?.description}
											</div>
										</div>
									</div>
								</DialogPanel>
							</div>
						</div>
					</Dialog>
				]
			}
		</ModalContext.Provider>
	);
}


export const useModal = () => useContext(ModalContext)